(function () {
  var s = document.currentScript, map = s && s.getAttribute('data-terms');
  if (!map) return;
  function run() {
    fetch(map).then(function (r) { return r.json(); }).then(function (T) {
      var roots = document.querySelectorAll('.recipe-article__intro, .recipe-article__body, .recipe-article__panel');
      if (!roots.length) return;
      var here = location.pathname, pats = [];
      T.forEach(function (t) { t[1].forEach(function (n) {
        pats.push({ h: t[0], n: n, re: new RegExp('(^|[^\\w\\u00C0-\\u017F])(' + n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:s|es)?)(?![\\w\\u00C0-\\u017F])', 'i') });
      }); });
      pats.sort(function (a, b) { return b.n.length - a.n.length; });
      var used = {}, count = 0, MAX = 5, van = 0,
        VAN = { 'vanilla-bean': 1, 'vanilla-extract': 1, 'vanilla-bean-paste': 1, 'bourbon-vanilla': 1, 'tahitian-vanilla': 1 };
      function ok(node) {
        for (var p = node.parentNode; p && p !== document.body; p = p.parentNode) {
          if (/^(A|H1|H2|H3|H4|H5|H6|BUTTON|SCRIPT|STYLE|LABEL|SUMMARY|FIGCAPTION|INPUT|TEXTAREA)$/.test(p.nodeName)) return false;
          if (p.hasAttribute && (p.hasAttribute('data-vge-nolink') || /kk-|vg-recipe-gear|vg-bake/.test(String(p.className || '')))) return false;
        }
        return true;
      }
      roots.forEach(function (root) {
        var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
        while ((n = w.nextNode())) { if (n.nodeValue.trim().length > 3 && ok(n)) nodes.push(n); }
        nodes.forEach(function (node) {
          if (count >= MAX) return;
          for (var i = 0; i < pats.length && count < MAX; i++) {
            var p = pats[i]; if (used[p.h] || (VAN[p.h] && van)) continue;
            var m = p.re.exec(node.nodeValue); if (!m) continue;
            var url = '/pages/encyclopedia/' + p.h; if (url === here) continue;
            var start = m.index + m[1].length, a = document.createElement('a');
            a.href = url; a.className = 'vge-term'; a.title = 'What is ' + m[2] + '? Dessert Encyclopedia';
            var after = node.splitText(start); after.splitText(m[2].length);
            a.textContent = after.nodeValue; after.parentNode.replaceChild(a, after);
            used[p.h] = 1; if (VAN[p.h]) van = 1; count++; return;
          }
        });
      });
    }).catch(function () {});
  }
  if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 800);
})();
